module.exports = __webpack_public_path__ + "img/kakomon_banner_2023.6fb4b0d9.jpg";